import styles from './ProductCardOkoOption.module.scss';
import ProductCardNonBuyableLegacy from '../ProductCardNonBuyable/ProductCardNonBuyable';
import React from 'react';
import { DialogDisclosure } from '@ariakit/react';
import { Button, Heading, Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const ProductCardOkoOptionLegacy = ({
  product,
  orderDialog,
  handleLinkClick,
  registerButton,
}) => {
  const noOkoAndPhone = !product.oko || !product.phone || !product.show_oko;
  return (
    <>
      {registerButton && (
        <div className={classNames(styles.cta)}>{registerButton}</div>
      )}
      {!registerButton && !noOkoAndPhone && (
        <ProductCardNonBuyableLegacy
          phone={product.phone}
          specials={['Indexierter Preis mit monatlicher Preisveränderung']}
          subtitle="Jetzt telefonisch anmelden"
          title={
            <Heading as="span" noSpacing size="h7" theme="neutral">
              Öko-Option telefonisch anmelden
            </Heading>
          }
        />
      )}
      {!registerButton && noOkoAndPhone && product.customer_type === 'all' && (
        <DialogDisclosure
          className={styles.cta}
          render={<Button isElevated />}
          store={orderDialog}
        >
          TARIF ANMELDEN
        </DialogDisclosure>
      )}
      {!registerButton &&
        noOkoAndPhone &&
        product.customer_type === 'newcustomers' &&
        product.new_customer_urls?.length > 0 && (
          <DialogDisclosure
            className={styles.cta}
            render={<Button isElevated />}
            store={orderDialog}
          >
            TARIF ANMELDEN
          </DialogDisclosure>
        )}
      {!registerButton &&
        noOkoAndPhone &&
        product.customer_type === 'newcustomers' &&
        !product.new_customer_urls?.length && (
          <Button
            className={styles.cta}
            isElevated
            onClick={handleLinkClick(product.new_customer_url)}
            render={<Link to={product.new_customer_url} />}
          >
            TARIF ANMELDEN
          </Button>
        )}
      {!registerButton &&
        noOkoAndPhone &&
        product.customer_type === 'existingcustomers' && (
          <Button
            className={styles.cta}
            isElevated
            onClick={handleLinkClick(product.existing_customer_url)}
            render={<Link to={product.existing_customer_url} />}
          >
            TARIF ANMELDEN
          </Button>
        )}
    </>
  );
};

export default ProductCardOkoOptionLegacy;
